/**
 * Entry point for the React app.
 * element and renders the App component to the DOM.
 *
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
